import { create, type StateCreator } from 'zustand';
import { darkThemeSafeLocalStorage } from '../lib/storage/storageImplementations';

interface DarkModeState {
  isDark: boolean;
  darkModeChange: (bool: boolean) => void;
}

const store: StateCreator<DarkModeState> = (_set) => ({
  isDark: darkThemeSafeLocalStorage.get() === 'dark',
  darkModeChange: (bool: boolean | 'light' | 'dark') =>
    _set(() => {
      if (bool === 'light' || bool === 'dark') {
        window.__setPreferredTheme?.(bool);
        return { isDark: bool === 'dark' };
      }
      window.__setPreferredTheme?.(bool ? 'dark' : 'light');
      return { isDark: bool };
    }),
});

const useIsDarkModeStore = create<DarkModeState>()(store);

export default useIsDarkModeStore;
